import { Modal, Paragraph } from 'ui'

interface Props {
  open: boolean
  onCreate: () => void
  onClose: () => void
}

export const CreateOnDemandDeliveryModal = ({
  open,
  onCreate,
  onClose,
}: Props) => {
  return (
    <Modal
      open={open}
      title={'Create an On-Demand Delivery'}
      okText={'Create'}
      showCancel={false}
      onClose={onClose}
      onOk={({ closeModal }) => {
        onCreate()
        closeModal()
      }}
    >
      <Paragraph>
        WorkWhile's On-Demand Delivery feature is designed to help ensure that
        expectations and requirements for deliveries are clearly communicated.
        Businesses are guided through a structured setup process to define these
        details, which are then clearly presented to workers when they reserve a
        delivery block and show up on site.
      </Paragraph>
    </Modal>
  )
}
